/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bool, func, shape, string, number, arrayOf, oneOfType, oneOf } from "prop-types";
import { compose } from "redux";

import { selectors as servicePaymentsSelectors, actions as servicePaymentsActions } from "reducers/servicePayments";
import { actions as paymentsAFIPActions } from "reducers/paymentsAFIP";
import { actions as thirdPaymentActions } from "reducers/thirdPayment";
import { selectors as statusSelectors } from "reducers/status";

import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import * as accountUtils from "util/accounts";
import { getServicePaymentsPath } from "util/servicePaymentsRoutes";

import TransactionTicket from "pages/_components/TransactionTicket";
import ContextMenu from "pages/_components/ContextMenu";
import { resizableRoute } from "pages/_components/Resizable";
import { resolveEmbeddedV3GoBackPath } from "util/v3ShellLayoutSync";
import { resolveServicePaymentsExitHref } from "util/servicePaymentsExitNavigation";
import NewPaymentTransactionData from "./_components/NewPaymentTransactionData";

const FORM_ID = "services.newPayment";

class NewPaymentTicket extends Component {
    static propTypes = {
        summary: shape({}).isRequired,
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        loggedUser: shape({
            accessToken: string,
            defaultAvatarId: string,
            email: string,
            previousLoginInfo: arrayOf(
                shape({
                    city: string,
                    country: string,
                    date: string,
                    idUser: string,
                    ip: string,
                    latitude: number,
                    longitude: number,
                }),
            ),
        }),
        debinDetail: bool.isRequired,
        fetching: bool,
        fetchingAccounts: bool,
        accounts: shape({}),
        history: shape({}).isRequired,
        embeddedInV3Shell: bool,
        pathname: string.isRequired,
        location: shape({
            pathname: string.isRequired,
        }).isRequired,
        moduleEntryPath: oneOfType([string, oneOf([null])]),
    };

    static defaultProps = {
        loggedUser: null,
        fetching: false,
        fetchingAccounts: false,
        accounts: null,
        embeddedInV3Shell: false,
        moduleEntryPath: null,
    };

    state = {
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { summary, dispatch } = this.props;

        if (!summary && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        }
        dispatch(thirdPaymentActions.setNotRememberFormData());
    }

    centerContentMobile = (isDesktop) => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ margin: isDesktop && "-0.5rem 2rem" }}>
                {i18nUtils.get("services.newPayment.summary.title")}
            </h1>
        </div>
    );

    exportPdf = async () => {
        this.setState({ fetchingDownload: true });
        const { summary, dispatch } = this.props;
        const { summaryInfo } = summary;

        const ticketData = {
            ticketName: i18nUtils.get("services.newPayment.summary.title"),
            ticketBody: [
                getGeneralTicketItem(`negotiate.transaction.date.label`, summary?.submitDateTime, "datefulltime"),
                getGeneralTicketItem(
                    `echeq.transaction.voucher`,
                    summary?.idTransaction.substring(0, 8).toUpperCase(),
                    "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.rubros.label`, summaryInfo?.selectedRubro?.description, "string"),
                getGeneralTicketItem(`${FORM_ID}.entities.label`, summaryInfo?.selectedEntity?.description, "string"),
                getGeneralTicketItem(`${FORM_ID}.cpe.label`, summaryInfo?.selectedCPE, "string"),
                getGeneralTicketItem(`${FORM_ID}.amountToPay`, summaryInfo?.selectedAmountToPay, "amountARS"),
                getGeneralTicketItem(
                    `${FORM_ID}.expiration`,
                    summaryInfo?.selectedConceptExpirationDate,
                    summaryInfo?.selectedEntity?.handleBaseDebts ? "date" : "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.concept`, summaryInfo?.selectedConcept?.description, "string"),
                getGeneralTicketItem(
                    `${FORM_ID}.account.label`,
                    summaryInfo?.selectedDebitAccount &&
                        accountUtils.getIncomingDebinAccountName(summaryInfo.selectedDebitAccount),
                    "string",
                ),
                getGeneralTicketItem(
                    `${FORM_ID}.paymentReference`,
                    summaryInfo?.paymentReference ? summaryInfo?.paymentReference : "",
                    "string",
                ),
            ],
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18nUtils.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    resolveBackTarget = () => {
        const { pathname, moduleEntryPath, location } = this.props;
        const currentPathname = location?.pathname || "";
        if (pathname === "/pendingTransaction/list" || pathname === "/transactions/list") {
            return pathname;
        }
        let target = resolveEmbeddedV3GoBackPath("/servicePayments", pathname);
        if (target === "/servicePayments") {
            target = resolveServicePaymentsExitHref({
                moduleEntryPath,
                lastPathname: pathname,
                currentPathname,
            });
        }
        return target;
    };

    handleBack = () => {
        const { dispatch, pathname } = this.props;
        dispatch(servicePaymentsActions.cleanUp());
        dispatch(paymentsAFIPActions.cleanUp());
        dispatch(
            push(
                pathname === "/pendingTransaction/list" || pathname === "/transactions/list"
                    ? pathname
                    : getServicePaymentsPath(),
            ),
        );
        dispatch(servicePaymentsActions.setModuleEntryPath(null));
    };

    buttonsDetail = () => {
        const { dispatch } = this.props;
        const newLabel = configUtils.getBoolean("frontend.Show.ContextualMenu.Functionalities", false);

        return [
            {
                label: "services.newPayment.confirmationTicket.goToDesktop",
                bsStyle: "outline",
                onClick: () => dispatch(push(`/desktop`)),
            },
            {
                label: `services.newPayment.confirmationTicket.goToPayments${newLabel ? ".arca" : ""}`,
                bsStyle: "primary",
                onClick: () => {
                    dispatch(servicePaymentsActions.cleanUp());
                    dispatch(paymentsAFIPActions.cleanUp());
                    dispatch(push(getServicePaymentsPath()));
                },
            },
        ];
    };

    rightContentTransactionScheme = (isFinished) => {
        const { isDesktop, summary } = this.props;

        if (isDesktop || isFinished) {
            return <></>;
        }

        return (
            <>
                {summary?.idTransactionStatus !== "CANCELLED" ||
                    (summary?.idTransactionStatus !== "FAILED" && (
                        <ContextMenu
                            isDesktop={isDesktop}
                            color="white"
                            buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                            items={[
                                {
                                    label: "pendingTransaction.info.scheme",
                                    onClick: () => this.setState({ showDrawerMobile: true }),
                                },
                            ]}
                        />
                    ))}
            </>
        );
    };

    render() {
        const { summary, isDesktop, isSmallDesktop, fetching, embeddedInV3Shell } = this.props;
        const { showDrawerMobile, fetchingDownload } = this.state;
        const isFinished = summary?.idTransactionStatus === "FINISHED";

        return (
            <>
                {summary && (
                    <TransactionTicket
                        embeddedInV3Shell={embeddedInV3Shell}
                        embeddedV3GoBackPath={getServicePaymentsPath()}
                        handleBack={this.handleBack}
                        notificationScope="forms"
                        handleClick={this.exportPdf}
                        handleClickMessage="global.download"
                        uniqueDownload={isFinished}
                        rightContent={() => this.rightContentTransactionScheme(isFinished)}
                        downloadImageWhite={!isDesktop}
                        headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                        centerElement={isDesktop ? undefined : this.centerContentMobile}
                        hasInlineButtons
                        hideMobileMenu={!isDesktop}
                        summary={summary}
                        fetching={fetching}
                        generateSignFunction
                        ignoreHomeButton
                        buttonsDetail={this.buttonsDetail()}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        summaryTitle="services.newPayment.summary.title"
                        showDrawerMobile={showDrawerMobile}
                        closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                        isFetchingExport={fetchingDownload}>
                        <NewPaymentTransactionData {...this.props} FORM_ID={FORM_ID} />
                    </TransactionTicket>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: servicePaymentsSelectors.getSummary(state),
    fetching: servicePaymentsSelectors.getFetching(state),
    pathname: statusSelectors.getPathname(state),
    moduleEntryPath: servicePaymentsSelectors.getModuleEntryPath(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(NewPaymentTicket);
